var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoArriere(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500.91 442.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e30613;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "INTERFACE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M436.07,64.83C394.26,23.03,338.67,0,279.55,0S164.83,23.03,123.02,64.83c-41.81,41.81-64.83,97.4-64.83,156.52,0,11.81,.92,23.49,2.73,34.93h47.56c-2.3-11.29-3.52-22.97-3.52-34.93,0-96.27,78.32-174.59,174.59-174.59s174.59,78.32,174.59,174.59-78.32,174.59-174.59,174.59c-49.61,0-94.46-20.8-126.27-54.14l-33.13,33.13c.95,.99,1.91,1.98,2.88,2.95,41.81,41.81,97.4,64.83,156.52,64.83s114.72-23.03,156.53-64.83c41.81-41.81,64.83-97.4,64.83-156.52s-23.03-114.72-64.83-156.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "196.96 167.45 255.22 146.21 255.22 296.51 229.08 296.51 229.08 185.28 196.96 196.31 196.96 167.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.91,146.21c-24.96,0-45.2,20.24-45.2,45.2v59.9c0,24.96,20.24,45.2,45.2,45.2s45.2-20.24,45.2-45.2v-59.9c0-24.96-20.24-45.2-45.2-45.2Zm19.02,105.13c0,10.49-8.53,19.03-19.02,19.03s-19.03-8.54-19.03-19.03v-59.97c0-10.49,8.53-19.02,19.03-19.02s19.02,8.54,19.02,19.02v59.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.92,309.41l71.02-68.18c7.25-6.96,2.32-19.2-7.72-19.2H11.18c-10.05,0-14.97,12.24-7.72,19.2l71.02,68.18c4.32,4.14,11.13,4.14,15.45,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoArriere);
export default __webpack_public_path__ + "static/media/PICTO_ARRIERE.3a479632a0eae8d186585c473ede258d.svg";
export { ForwardRef as ReactComponent };